import { Injectable } from "@angular/core";
import { ParkingSpace } from "../classes/ParkingSpace";
import { HttpHeaders, HttpParams, HttpClient } from "@angular/common/http";
import { routes } from "../config/routes";
import { Error } from "../classes/Error";
import { httpStatus, httpHeaders } from "../config/httpStatus";
import { map, catchError } from "rxjs/operators";
import {Observable, of} from "rxjs";
import { ErrorService } from "./error.service";

@Injectable({
  providedIn: "root",
})
export class ParkingSpaceService {
  private controller: string;

  constructor(private http: HttpClient, private errorService: ErrorService) {
    this.controller = "ParkingSpaces";
  }

  private getUrl() {
    return routes.api + this.controller + "/";
  }

  public addParkingSpace(parkingSpace: ParkingSpace) {
    let err = new Error();
    let body = new HttpParams().set("parkingSpace", parkingSpace.toJson());
    let errorMessage =
      "No hemos podido actualizar la plaza de garaje. Vuelve a intentarlo";

    return this.http
      .post(this.getUrl() + "addParkingSpace", body.toString(), {
        headers: httpHeaders,
      })
      .pipe(
        map((res: Error) => {
          if (res.status == httpStatus.success) {
            err.setData(parkingSpace);
            return err;
          } else {
            err.setError(errorMessage);
            this.errorService.notifyError(
              res,
              errorMessage,
              "Ups..!",
              "parking-space.service"
            );
            return err;
          }
        })
      );
  }

  public getParkingSpaceById(id: number): Observable<ParkingSpace | null> {
    return this.http.get<ParkingSpace>(this.getUrl() + id).pipe(
      map((res: any) => {
        if (res && res.id) {
          return new ParkingSpace(res);
        } else {
          return null;
        }
      }),
      catchError((err) => {
        this.errorService.notifyError(
          err,
          "No se pudo obtener la plaza de garaje",
          "Ups..!",
          "parking-space.service"
        );
        return of(null);
      })
    );
  }
}
